import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5bfc0b6c&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=5bfc0b6c&prod&lang=less&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=5bfc0b6c&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc0b6c",
  null
  
)

export default component.exports